import type { LeafletEvent, Path } from "leaflet";
import { MAP_EXPORT_PARCEL_POLYGON_CLASS } from "../constants/mapExport";

/**
 * 地番ポリゴンの add イベントで、地図出力（PNG/PDF/プレビュー）に含める
 * 目印となるマーカークラスを path 要素へ直接付与する。
 *
 * react-leaflet の pathOptions.className はレイヤーが地図へ追加された後に
 * setStyle で適用されるが、Leaflet は className を生成時（_initPath）にしか
 * DOM へ反映しないため、pathOptions 経由では付与できない。
 */
export const addParcelPolygonExportClass = (event: LeafletEvent): void => {
  const element = (event.target as Path).getElement();
  element?.classList.add(MAP_EXPORT_PARCEL_POLYGON_CLASS);
};
